var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6969 1.76286C17.2133 -0.325426 13.3762 -0.0117537 11 2.40739C8.62383 -0.0117537 4.78672 -0.329723 2.30313 1.76286C-0.92812 4.48278 -0.455464 8.91715 1.84766 11.2675L9.38438 18.9461C9.81407 19.3843 10.3898 19.6293 11 19.6293C11.6145 19.6293 12.1859 19.3886 12.6156 18.9504L20.1524 11.2718C22.4512 8.92145 22.9324 4.48708 19.6969 1.76286ZM18.6828 9.8195L11.1461 17.498C11.043 17.6011 10.957 17.6011 10.8539 17.498L3.31719 9.8195C1.74883 8.22106 1.43086 5.19606 3.63086 3.34411C5.30235 1.93903 7.88047 2.14957 9.4961 3.79528L11 5.32926L12.5039 3.79528C14.1281 2.14098 16.7063 1.93903 18.3691 3.33981C20.5648 5.19176 20.2383 8.23395 18.6828 9.8195Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a680a5d6.svg";
export { ForwardRef as ReactComponent };